export function isEmpty(arr?: Array<any>): boolean {
    if (arr === undefined || arr === null) {
        return true;
    }

    return arr.length === 0;
}
